import { graphql } from 'msw'
import db from '../db'

const demandBlockingsHandlers = [
  graphql.query('demandBlockings', (req, res, ctx) => {
    const filteredRows = db.demandBlockings.getAll()

    return res(
      ctx.data({
        demandBlockings: {
          pageInfo: {
            endCursor: 2,
            hasNextPage: false,
            totalPages: 1,
          },
          nodes: filteredRows,
          publisherAppBundles: ['se.ace.brofist', 'alex.com'],
        },
      })
    )
  }),

  graphql.mutation('exportDemandBlockings', (req, res, ctx) => {
    return res(ctx.data({ exportDemandBlockings: { message: 'Success' } }))
  }),
]

export default demandBlockingsHandlers
